import { Typography } from '@kinetik/ui-kit';
import { Stack } from '@mui/material';
import PropTypes from 'prop-types';
import React, { memo } from 'react';

import { COLORS } from 'theme';

/**
 * DropdownOptionLabel
 *
 * Renders a dropdown option row as "<label> — <summary>", the label in primary
 * text and the summary muted, joined by a non-breaking space so the dash can't
 * wrap away from the label.
 *
 * Pass this to a `Dropdown`'s `getOptionLabel`. The closed field almost always
 * wants the bare label instead, so pair it with a `getSelectedLabel` that
 * returns a plain string — without one, the Dropdown derives its display text
 * from `getOptionLabel` and string-joins the result, rendering this element as
 * "[object Object]".
 *
 * @param {Object} props
 * @param {string} props.label - The option's name
 * @param {string} [props.summary] - Short trailing description; omitted renders the label alone
 */
const DropdownOptionLabel = ({ label, summary }) => (
  <Stack direction="row">
    <Typography variant="body1-medium" color={COLORS.kinetikBlack}>
      {label}
    </Typography>
    {summary ? (
      <Typography variant="body1-regular" color={COLORS.black60}>
        {`\u00A0\u2014 ${summary}`}
      </Typography>
    ) : null}
  </Stack>
);

DropdownOptionLabel.propTypes = {
  label: PropTypes.string,
  summary: PropTypes.string,
};

export default memo(DropdownOptionLabel);
